import { useTranslation } from 'next-i18next'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'
import SeoHead from '@/components/seo/SeoHead'

export default function PageLegalNotice() {
  const { t } = useTranslation('legalNotice')

  return (
    <>
      <SeoHead
        title={t('title')}
        description={t('description')}
        dePath="impressum"
        enPath="legal-notice"
      />

      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="legal-notice" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'legalNotice'])
export { getStaticPaths, getStaticProps }
